import React, { useState, useRef } from "react";
import {
  Box,
  Button,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Link,
} from "@mui/material";
import { FaWhatsapp } from "react-icons/fa";

const SolicitacaoItem = ({
  solicitacao,
  expandedId,
  toggleExpand,
  handleWhatsappClick,
  openPopup,
  openFichaModal,
  openGenerateLinkModal,
  statusSelecionado,
  diasUteis,
  openFullscreenImage,
  isFichaPacienteButtonDisabled,
  userName,
}) => {
  const [pressed, setPressed] = useState(null);
  const touchHandledRef = useRef(false);

  if (!solicitacao) return null;

  const isExpanded = expandedId === solicitacao.id;

  const handlePressStart = (e) => {
    if (e.target.tagName === "BUTTON" || e.target.tagName === "A") return;
    setPressed(solicitacao.id);
    touchHandledRef.current = false;
  };

  const handlePressEnd = (e) => {
    if (e.target.tagName === "BUTTON" || e.target.tagName === "A") return;
    setPressed(null);
    if (!touchHandledRef.current) {
      toggleExpand(solicitacao.id);
    }
  };

  const handleTouchEnd = (e) => {
    touchHandledRef.current = true;
    handlePressEnd(e);
  };

  return (
    <Box
      key={solicitacao.id}
      sx={{
        mt: 1,
        p: 1.5,
        border: "1px solid #ddd",
        borderRadius: 2,
        backgroundColor:
          statusSelecionado === "PENDENTE" && diasUteis > 2
            ? "#ffe5e5"
            : "#f9f9f9",
        cursor: "pointer",
        transition: "transform 0.15s ease-in-out",
        transform: pressed === solicitacao.id ? "scale(0.97)" : "scale(1)",
      }}
      onMouseDown={handlePressStart}
      onMouseUp={handlePressEnd}
      onTouchStart={handlePressStart}
      onTouchEnd={handleTouchEnd}
    >
      {/* Resumo da Solicitação */}
      <Box
        sx={{
          mb: 1,
          display: "flex",
          gap: 2,
          alignItems: "center",
          width: "100%",
          flexWrap: "wrap",
        }}
      >
        <Typography
          sx={{
            flexGrow: 1,
            maxWidth: "100%",
            minWidth: "150px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={`Serviço: ${solicitacao.nomeServico}`}
        >
          <strong>Serviço:</strong> {solicitacao.nomeServico}
        </Typography>

        <Typography
          sx={{
            flexGrow: 1,
            maxWidth: "100%",
            minWidth: "150px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={`Protocolo: ${solicitacao.protocolo}`}
        >
          <strong>Protocolo:</strong> {solicitacao.protocolo}
        </Typography>

        <Typography sx={{ flexGrow: 1 }}>
          <strong>Data:</strong>{" "}
          {new Date(solicitacao.dataSolicitacao).toLocaleDateString()}
        </Typography>

        {solicitacao.telefone && (
          <Button
            variant="contained"
            color="success"
            size="small"
            startIcon={<FaWhatsapp />}
            sx={{ flexGrow: 1, maxWidth: "33%", minWidth: "150px" }}
            onClick={(e) => {
              e.stopPropagation(); // Evita que o clique afete a expansão
              handleWhatsappClick(
                solicitacao.solicitante,
                solicitacao.telefone,
                solicitacao.nomeServico,
                solicitacao.protocolo
              );
            }}
          >
            WhatsApp
          </Button>
        )}
      </Box>

      {isExpanded && (
        <Box>
          {statusSelecionado === "PENDENTE" && diasUteis > 2 && (
            <Typography sx={{ color: "error.main", fontWeight: "bold", mb: 1 }}>
              ⚠️ Solicitação há mais de 48h úteis
            </Typography>
          )}

          <Typography>
            <strong>Categoria:</strong> {solicitacao.categoriaServico}
          </Typography>
          <Typography>
            <strong>Data Conclusão:</strong>{" "}
            {solicitacao.dataConclusao || "Pendente"}
          </Typography>

          {solicitacao.documentos && solicitacao.documentos.length > 0 ? (
            <TableContainer component={Paper} sx={{ mt: 2 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Tipo</TableCell>
                    <TableCell>Arquivo</TableCell>
                    <TableCell>Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {solicitacao.documentos.map((doc) => (
                    <TableRow key={doc.id}>
                      <TableCell>{doc.tipo}</TableCell>
                      <TableCell>
                        <Link
                          href={doc.fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Baixar
                        </Link>
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={(e) => {
                            e.stopPropagation();
                            openFullscreenImage(doc.fileUrl);
                          }}
                        >
                          Visualizar
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography color="textSecondary" align="center" sx={{ mt: 2 }}>
              Nenhum documento enviado
            </Typography>
          )}

          {statusSelecionado === "PENDENTE" && (
            <Box sx={{ mt: 2 }}>
              <Typography>
                <strong>Solicitar Novos Documentos:</strong>
              </Typography>

              <Button
                variant="contained"
                color="primary"
                size="small"
                sx={{ mt: 1 }}
                onClick={(e) => {
                  e.stopPropagation();
                  openFichaModal(userName.split("-")[1].trim());
                }}
                disabled={isFichaPacienteButtonDisabled}
              >
                Ficha Paciente
              </Button>

              <Button
                variant="contained"
                color="primary"
                size="small"
                sx={{ mt: 1 }}
                onClick={(e) => {
                  e.stopPropagation();
                  openGenerateLinkModal(solicitacao.id);
                }}
              >
                Gerar Link
              </Button>

              <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
                <Button
                  variant="contained"
                  color="success"
                  onClick={(e) => {
                    e.stopPropagation();
                    openPopup(solicitacao, "ACEITAR");
                  }}
                >
                  Aceitar
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={(e) => {
                    e.stopPropagation();
                    openPopup(solicitacao, "NEGAR");
                  }}
                >
                  Negar
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default SolicitacaoItem;
